export enum PresetsManagerTabsEnum {
  TIME_PERIODS = 'time-periods',
  YIELD_PRESETS = 'yield-presets',
  WEATHER_PRESETS = 'weather-presets',
}
